/* Metacards v3 — interactions. No dependencies. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var coarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;

  /* ---------- Shared 3D tilt engine ---------- */
  function tilt(stage, opts) {
    opts = opts || {};
    var t = { rx: 0, ry: 0, gx: 30, gy: 20 }, raf = 0, dragging = false, moved = false, sx = 0, sy = 0, flipped = false;
    function paint() {
      raf = 0;
      stage.style.setProperty('--rx', t.rx.toFixed(2)); stage.style.setProperty('--ry', t.ry.toFixed(2));
      stage.style.setProperty('--ay', Math.abs(t.ry).toFixed(1));
      stage.style.setProperty('--gx', t.gx.toFixed(1)); stage.style.setProperty('--gy', t.gy.toFixed(1));
    }
    function queue() { if (!raf) raf = requestAnimationFrame(paint); }
    function rel(e) {
      var r = stage.getBoundingClientRect();
      return [Math.min(1, Math.max(0, (e.clientX - r.left) / r.width)), Math.min(1, Math.max(0, (e.clientY - r.top) / r.height))];
    }
    function on() { stage.classList.add('is-active'); }
    function rest() { stage.classList.remove('is-active'); t.rx = 0; t.ry = 0; queue(); }
    stage.addEventListener('pointermove', function (e) {
      if (e.pointerType === 'mouse') { on(); var p = rel(e); t.rx = (0.5 - p[1]) * 28; t.ry = (p[0] - 0.5) * 40; t.gx = p[0] * 100; t.gy = p[1] * 100; queue(); }
      else if (dragging) {
        var dx = e.clientX - sx, dy = e.clientY - sy;
        if (Math.abs(dx) > 6 || Math.abs(dy) > 6) moved = true;
        on(); t.ry = Math.max(-55, Math.min(55, dx / 2.6)); t.rx = Math.max(-28, Math.min(28, -dy / 4));
        var p2 = rel(e); t.gx = p2[0] * 100; t.gy = p2[1] * 100; queue();
      }
    });
    stage.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') { dragging = true; moved = false; sx = e.clientX; sy = e.clientY; } });
    function end() { if (dragging) { dragging = false; setTimeout(rest, 300); } }
    stage.addEventListener('pointerup', end); stage.addEventListener('pointercancel', end);
    stage.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') rest(); });
    function setFlip(v) { flipped = v; stage.style.setProperty('--flip', v ? 180 : 0); if (opts.onFlip) opts.onFlip(v); }
    if (opts.clickFlip) {
      stage.addEventListener('click', function () { if (moved) { moved = false; return; } setFlip(!flipped); });
      stage.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setFlip(!flipped); } });
    }
    /* phone tilt */
    function orient(e) {
      if (e.gamma == null || dragging) return;
      var r = stage.getBoundingClientRect(); if (r.bottom < 0 || r.top > innerHeight) return;
      on(); t.ry = Math.max(-35, Math.min(35, e.gamma)); t.rx = Math.max(-22, Math.min(22, ((e.beta || 45) - 45) * -0.5));
      t.gx = 50 + t.ry; t.gy = 50 - t.rx; queue();
    }
    return {
      setFlip: setFlip, isFlipped: function () { return flipped; },
      gyro: function () { window.addEventListener('deviceorientation', orient, { passive: true }); }
    };
  }
  var gyroListeners = [];
  function enableGyro() { gyroListeners.forEach(function (c) { c.gyro(); }); gyroListeners = []; document.querySelectorAll('[data-mc-gyro]').forEach(function (b) { b.hidden = true; }); }
  function offerGyro(ctrl) {
    if (!coarse || reduce || !('DeviceOrientationEvent' in window)) return;
    if (typeof DeviceOrientationEvent.requestPermission === 'function') {
      gyroListeners.push(ctrl);
      document.querySelectorAll('[data-mc-gyro]').forEach(function (b) {
        if (b.dataset.mcBound) return; b.dataset.mcBound = '1'; b.hidden = false;
        b.addEventListener('click', function () { DeviceOrientationEvent.requestPermission().then(function (s) { if (s === 'granted') enableGyro(); }).catch(function () {}); });
      });
    } else { ctrl.gyro(); }
  }

  /* ---------- Hero ---------- */
  function initHero(root) {
    if (root.dataset.mcReady) return; root.dataset.mcReady = '1';
    var stage = root.querySelector('[data-mc-stage]'); if (!stage) return;
    var hint = root.querySelector('[data-mc-hint]');
    var front = root.querySelector('[data-mc-front]'), back = root.querySelector('[data-mc-back]');
    var nameEl = root.querySelector('[data-mc-name]'), priceEl = root.querySelector('[data-mc-price]');
    var links = root.querySelectorAll('[data-mc-link]');
    var ctrl = tilt(stage, { clickFlip: true, onFlip: function (v) { if (hint) hint.textContent = v ? hint.dataset.back : hint.dataset.front; } });
    offerGyro(ctrl);
    root.querySelectorAll('[data-mc-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.querySelectorAll('[data-mc-thumb]').forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        var img = front.querySelector('img'), pre = new Image();
        pre.onload = function () {
          img.src = btn.dataset.img; img.srcset = btn.dataset.srcset || ''; img.alt = btn.dataset.alt || '';
          img.classList.toggle('is-flat', btn.dataset.flat === '1'); front.style.setProperty('--z', btn.dataset.zoom || 121);
        };
        pre.src = btn.dataset.img;
        if (back) back.className = back.className.replace(/mc-fin--[\w-]+/g, '').trim() + ' mc-fin--' + (btn.dataset.back || 'black-silver');
        if (nameEl) nameEl.textContent = btn.dataset.name || '';
        if (priceEl) priceEl.textContent = btn.dataset.price || '';
        links.forEach(function (a) { if (btn.dataset.url) a.href = btn.dataset.url; });
        if (ctrl.isFlipped()) ctrl.setFlip(false);
      });
    });
  }

  /* ---------- Builder ---------- */
  function initBuilder(root) {
    if (root.dataset.mcReady) return; root.dataset.mcReady = '1';
    var stage = root.querySelector('[data-mc-stage]');
    var faces = [root.querySelector('[data-mc-bface]'), root.querySelector('[data-mc-bback]')];
    var finLabel = root.querySelector('[data-mc-fin-label]');
    var nameOuts = root.querySelectorAll('[data-mc-name-out], [data-mc-name-out2]');
    var nameDef = (root.querySelector('[data-mc-name-out]') || {}).dataset ? root.querySelector('[data-mc-name-out]').dataset.default : 'Your Name';
    var mono = root.querySelector('[data-mc-mono]'), crest = root.querySelector('[data-mc-crest]'), artImg = root.querySelector('[data-mc-art-img]');
    var input = root.querySelector('[data-mc-name-input]'), file = root.querySelector('[data-mc-file]'), upHint = root.querySelector('[data-mc-upload-hint]');
    var go = root.querySelector('[data-mc-go]');
    var sides = root.querySelectorAll('[data-mc-side]');
    var state = { value: '', name: '', art: 'mono' };
    var variants = [];
    try { variants = JSON.parse((root.querySelector('[data-mc-variants]') || {}).textContent || '[]'); } catch (e) {}
    var ctrl = stage ? tilt(stage, { onFlip: function (v) { sides.forEach(function (s) { s.setAttribute('aria-pressed', (s.dataset.mcSide === 'back') === v ? 'true' : 'false'); }); } }) : null;
    if (ctrl) offerGyro(ctrl);
    sides.forEach(function (s) { s.addEventListener('click', function () { if (ctrl) ctrl.setFlip(s.dataset.mcSide === 'back'); }); });

    function initials(s) {
      var w = s.trim().split(/\s+/).filter(Boolean);
      return w.length ? w.map(function (x) { return x[0]; }).join('').slice(0, 2).toUpperCase() : (mono ? mono.dataset.default : 'M');
    }
    function link() {
      if (!go) return;
      var url = go.dataset.base, params = [];
      var norm = function (x) { return String(x).toLowerCase().replace(/[^a-z]/g, ''); };
      var v = variants.find(function (x) { return x.options.some(function (o) { return norm(o) === norm(state.value); }); });
      if (v) params.push('variant=' + v.id);
      if (state.name.trim()) params.push('mc_name=' + encodeURIComponent(state.name.trim()));
      params.push('mc_art=' + state.art);
      go.href = url + (url.indexOf('?') > -1 ? '&' : '?') + params.join('&');
    }
    function setArt(k) {
      state.art = k;
      root.querySelectorAll('[data-mc-art]').forEach(function (x) { x.setAttribute('aria-pressed', x.dataset.mcArt === k ? 'true' : 'false'); });
      if (mono) mono.hidden = k !== 'mono';
      if (crest) crest.hidden = k !== 'crest';
      if (artImg) artImg.hidden = !(k === 'upload' && artImg.getAttribute('src'));
      if (upHint) upHint.hidden = k !== 'upload';
      if (ctrl && ctrl.isFlipped()) ctrl.setFlip(false);
      link();
    }
    root.querySelectorAll('[data-mc-sw]').forEach(function (b) {
      b.addEventListener('click', function () {
        root.querySelectorAll('[data-mc-sw]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        faces.forEach(function (f) {
          if (!f) return;
          f.className = f.className.replace(/mc-fin--[\w-]+|is-dark|is-light/g, '').replace(/\s+/g, ' ').trim() + ' mc-fin--' + b.dataset.style + ' is-' + (b.dataset.tone || 'dark');
        });
        state.value = b.dataset.value || b.dataset.label;
        if (finLabel) finLabel.textContent = b.dataset.label;
        link();
      });
    });
    if (input) input.addEventListener('input', function () {
      state.name = input.value;
      nameOuts.forEach(function (n) { n.textContent = input.value.trim() || nameDef; });
      if (mono) mono.textContent = initials(input.value);
      link();
    });
    root.querySelectorAll('[data-mc-art]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.dataset.mcArt === 'upload' && file && !artImg.getAttribute('src')) { file.click(); return; }
        setArt(b.dataset.mcArt);
      });
    });
    if (file) file.addEventListener('change', function () {
      var f = file.files && file.files[0]; if (!f || !artImg) return;
      if (artImg.dataset.url) URL.revokeObjectURL(artImg.dataset.url);
      var u = URL.createObjectURL(f); artImg.dataset.url = u; artImg.src = u;
      setArt('upload');
    });
    var first = root.querySelector('[data-mc-sw][aria-pressed="true"]') || root.querySelector('[data-mc-sw]');
    if (first) first.click();
    setArt('mono');
  }

  /* ---------- How it works ---------- */
  function initHow(root) {
    if (root.dataset.mcReady) return; root.dataset.mcReady = '1';
    var tabs = root.querySelectorAll('[data-mc-tab]'), plans = root.querySelectorAll('[data-mc-plan]');
    function setStep(plan, i) {
      var steps = plan.querySelectorAll('[data-mc-step]'), n = steps.length; if (!n) return;
      i = (i + n) % n; plan.dataset.step = i;
      steps.forEach(function (s, k) {
        s.classList.toggle('is-open', k === i); s.classList.toggle('is-done', k <= i);
        var b = s.querySelector('button'); if (b) b.setAttribute('aria-expanded', k === i ? 'true' : 'false');
      });
      var bar = plan.querySelector('[data-mc-bar]'); if (bar) bar.style.width = Math.round((i + 1) / n * 100) + '%';
      var nx = plan.querySelector('[data-mc-next]'); if (nx) nx.textContent = i === n - 1 ? nx.dataset.restart : nx.dataset.next;
    }
    function show(i) {
      tabs.forEach(function (t, k) { t.setAttribute('aria-selected', k === i ? 'true' : 'false'); t.tabIndex = k === i ? 0 : -1; });
      plans.forEach(function (p, k) { p.hidden = k !== i; if (k === i) setStep(p, 0); });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { show(i); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { var j = (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length; tabs[j].focus(); show(j); }
      });
    });
    plans.forEach(function (plan) {
      plan.querySelectorAll('[data-mc-step]').forEach(function (s, k) { var b = s.querySelector('button'); if (b) b.addEventListener('click', function () { setStep(plan, k); }); });
      var nx = plan.querySelector('[data-mc-next]'), pv = plan.querySelector('[data-mc-prev]');
      if (nx) nx.addEventListener('click', function () { var i = +plan.dataset.step, n = plan.querySelectorAll('[data-mc-step]').length; setStep(plan, i >= n - 1 ? 0 : i + 1); });
      if (pv) pv.addEventListener('click', function () { setStep(plan, Math.max(0, +plan.dataset.step - 1)); });
    });
    show(0);
  }

  /* ---------- Sticky bar: hidden over hero, builder and footer ---------- */
  function initSticky(bar) {
    if (bar.dataset.mcReady) return; bar.dataset.mcReady = '1';
    if (!('IntersectionObserver' in window)) { bar.classList.add('is-on'); return; }
    var blockers = ['[data-mc-hero]', '[data-mc-builder]', 'footer'].map(function (s) { return document.querySelector(s); }).filter(Boolean);
    var vis = new Map();
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { vis.set(x.target, x.isIntersecting); });
      var blocked = false; vis.forEach(function (v) { if (v) blocked = true; });
      bar.classList.toggle('is-on', !blocked);
    }, { threshold: 0 });
    blockers.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Header ---------- */
  function initNav(nav) {
    if (nav.dataset.mcReady) return; nav.dataset.mcReady = '1';
    var btn = nav.querySelector('[data-mc-burger]'), menu = nav.querySelector('[data-mc-menu]');
    if (!btn || !menu) return;
    function set(open) {
      btn.setAttribute('aria-expanded', open ? 'true' : 'false'); menu.hidden = !open;
      if (open) menu.style.top = nav.getBoundingClientRect().bottom + 'px';
      document.body.classList.toggle('mc-lock', open);
    }
    btn.addEventListener('click', function () { set(menu.hidden); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !menu.hidden) set(false); });
    window.addEventListener('resize', function () { if (innerWidth >= 990 && !menu.hidden) set(false); });
  }

  /* ---------- Carry builder choices to the product page (saved on the order) ---------- */
  function prefillProduct() {
    var q = new URLSearchParams(location.search);
    var name = (q.get('mc_name') || '').trim(), art = q.get('mc_art');
    if (!name && !art) return;
    var forms = document.querySelectorAll('form[action*="/cart/add"]'); if (!forms.length) return;
    var labels = { mono: 'Monogram', crest: 'Crest', none: 'Name only', upload: 'Own design (file on WhatsApp)' };
    var artLabel = labels[art] || art || '';
    forms.forEach(function (f) {
      function put(k, v) {
        if (!v) return;
        var i = f.querySelector('input[name="properties[' + k + ']"]');
        if (!i) { i = document.createElement('input'); i.type = 'hidden'; i.name = 'properties[' + k + ']'; f.appendChild(i); }
        i.value = v;
      }
      put('Name on card', name); put('Artwork style', artLabel);
    });
    var field = Array.prototype.find.call(document.querySelectorAll('input[type="text"]'), function (i) {
      var n = (i.name + ' ' + (i.placeholder || '') + ' ' + (i.id || '')).toLowerCase();
      return n.indexOf('name') > -1 && n.indexOf('card number') === -1;
    });
    if (field && !field.value && name) { field.value = name; field.dispatchEvent(new Event('input', { bubbles: true })); }
    var btn = Array.prototype.find.call(document.querySelectorAll('button[name="add"]'), function (b) {
      return b.offsetParent !== null && !b.closest('sticky-add-to-cart, .sticky-add-to-cart, header, #header-group');
    });
    if (btn && !document.querySelector('.mc-choice')) {
      var note = document.createElement('p'); note.className = 'mc-choice';
      note.textContent = 'Your design: ' + [name ? '“' + name + '”' : '', artLabel].filter(Boolean).join(' · ') + ' — we confirm on WhatsApp before engraving.';
      var host = btn.parentElement; host.parentNode.insertBefore(note, host);
    }
  }

  function boot(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-mc-nav]').forEach(initNav);
    scope.querySelectorAll('[data-mc-hero]').forEach(initHero);
    scope.querySelectorAll('[data-mc-builder]').forEach(initBuilder);
    scope.querySelectorAll('[data-mc-how]').forEach(initHow);
    scope.querySelectorAll('[data-mc-sticky]').forEach(initSticky);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); prefillProduct(); });
  else { boot(); prefillProduct(); }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
